import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';

@Component({
  selector: 'app-shift',
  templateUrl: './shift.component.html',
  styleUrls: ['./shift.component.css']
})
export class ShiftComponent implements OnInit {

  constructor(private shiftService: HrService, private lookupService: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  ShiftModel = {
    ShiftID: 0,
    ShiftTypeID: 0,
    ShiftName: '',
    StartTime: moment(new Date()).format('DD-MMM-YYYY HH:mm'),
    EndTime: moment(new Date()).format('DD-MMM-YYYY HH:mm'),
    IntervalTime: moment(new Date()).format('DD-MMM-YYYY HH:mm'),
    IntervalDuration: 0,
    InTimeGrace: 0,
    OutTimeGrace: 0,
    TotalWorkingHour: 0,
    strStartTime: '',
    strEndTime: '',
    strIntervalTime: '',
    IsActive: false,
    IsSplit: false,
  }

  Clear() {
    this.ShiftModel.ShiftID = 0;
    this.ShiftModel.ShiftTypeID = 0;
    this.ShiftModel.ShiftName = '';
    this.ShiftModel.StartTime = '';
    this.ShiftModel.EndTime = '';
    this.ShiftModel.IntervalDuration = 0;
    this.ShiftModel.InTimeGrace = 0;
    this.ShiftModel.OutTimeGrace = 0;
    this.ShiftModel.TotalWorkingHour = 0;
    this.ShiftModel.IsActive = false;
    this.ShiftModel.IsSplit = false;
    this.ShiftModel.strStartTime = '';
    this.ShiftModel.strEndTime = '';
    this.ShiftModel.strIntervalTime = '';
    this.Submitted = false;
  };

  Validation() {
    return this.ShiftModel.ShiftTypeID == 0 || (this.ShiftModel.IsSplit && (this.ShiftModel.strIntervalTime == ''||this.ShiftModel.strIntervalTime==null));
  }
  Submitted = false;
  SaveShift(valid) {
    this.Submitted = true;
    
    if (valid && !this.Validation()) {
      this.spinnerService.show();
      this.ShiftModel.StartTime = this.ShiftModel.StartTime != null && this.ShiftModel.StartTime != '' ? moment(this.ShiftModel.StartTime).format('DD-MMM-YYYY HH:mm') : '';
      this.ShiftModel.EndTime = this.ShiftModel.EndTime != null && this.ShiftModel.EndTime != '' ? moment(this.ShiftModel.EndTime).format('DD-MMM-YYYY HH:mm') : '';
      this.ShiftModel.IntervalTime = this.ShiftModel.IntervalTime != null && this.ShiftModel.IntervalTime != '' ? moment(this.ShiftModel.IntervalTime).format('DD-MMM-YYYY HH:mm') : '';
      this.shiftService.SaveShift(JSON.stringify(this.ShiftModel)).subscribe((response) => {
        this.spinnerService.hide();
        if (response.webResponse.Status) {
          this.GetAllShift();
        }
        if (response.webResponse.Status && this.ShiftModel.ShiftID == 0) {
          this.Clear();
        }
        this.globalHelper.CheckActionStatus(response);
      });
    }
  };


  ShiftList: any;
  GetAllShift() {
    this.spinnerService.show();
    this.shiftService.GetAllShift().subscribe((data) => {
      this.spinnerService.hide();
      this.ShiftList = data.ShiftList;


    });
  };


  Edit(obj) {
    this.ShiftModel.ShiftID = obj.ShiftID;
    this.ShiftModel.ShiftName = obj.ShiftName;
    this.ShiftModel.StartTime = obj.StartTime != null && obj.StartTime != '' ? moment(obj.StartTime).format('DD-MMM-YYYY HH:mm') : '';
    this.ShiftModel.EndTime = obj.EndTime != null && obj.EndTime != '' ? moment(obj.EndTime).format('DD-MMM-YYYY HH:mm') : '';
    this.ShiftModel.IntervalTime = obj.IntervalTime != null && obj.IntervalTime != '' ? moment(obj.IntervalTime).format('DD-MMM-YYYY HH:mm') : '';
    this.ShiftModel.IntervalDuration = obj.IntervalDuration;
    this.ShiftModel.ShiftTypeID = obj.ShiftTypeID;
    this.ShiftModel.InTimeGrace = obj.InTimeGrace;
    this.ShiftModel.IsActive = obj.IsActive;
    this.ShiftModel.IsSplit = obj.IsSplit;
    this.ShiftModel.OutTimeGrace = obj.OutTimeGrace;
    this.ShiftModel.strStartTime = obj.strStartTime;
    this.ShiftModel.strEndTime = obj.strEndTime;
    this.ShiftModel.strIntervalTime = obj.strIntervalTime;
    this.ShiftModel.TotalWorkingHour = obj.TotalWorkingHour;
  };


  ShiftMarkActive(item) {

    this.ShiftModel.ShiftID = item.ShiftID;
    this.ShiftModel.IsActive = item.IsActive == true ? false : true;
    this.shiftService.ShiftMarkActive(this.ShiftModel.ShiftID, this.ShiftModel.IsActive).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllShift();
      }
      this.globalHelper.CheckActionStatus(data);
    });

  };
  ngOnInit() {
    this.GetShiftType();
    this.GetAllShift();
  }

  ShiftTypeList = [];
  GetShiftType() {
   
    this.lookupService.GetLookupsList('ShiftType', '').subscribe((data: any) => {
      this.ShiftTypeList = data.LookupItems;
    });
  };

}
